import { combineReducers } from 'redux';
import listSkinsReducer from './list';

// the default export is the reducer, which shapes the state
const reducer = combineReducers({
  list: listSkinsReducer,
});

export default reducer;
